import PhotoSwipeLightbox from "photoswipe-lightbox";

const initSubscriptionZoom = (root = document) => {
  root.querySelectorAll("[data-subscription-zoom]").forEach((link) => {
    if (link.dataset.zoomReady === "true" || !link.dataset.zoomSrc) return;
    link.dataset.zoomReady = "true";

    const images = [{
      src: link.dataset.zoomSrc,
      width: Number(link.dataset.zoomWidth) || 1200,
      height: Number(link.dataset.zoomHeight) || 1200,
    }];

    if (link.dataset.zoomSecondarySrc) {
      images.push({
        src: link.dataset.zoomSecondarySrc,
        width: Number(link.dataset.zoomSecondaryWidth) || 1200,
        height: Number(link.dataset.zoomSecondaryHeight) || 1200,
      });
    }

    const lightbox = new PhotoSwipeLightbox({
      dataSource: images,
      counter: images.length > 1,
      bgOpacity: 1,
      showHideAnimationType: "fade",
      pswpModule: () => import("photoswipe"),
    });

    lightbox.init();
    link.addEventListener("click", (event) => {
      event.preventDefault();
      lightbox.loadAndOpen(0);
    });
  });
};

initSubscriptionZoom();
document.addEventListener("shopify:section:load", (event) => initSubscriptionZoom(event.target));
